import Index from "./index";
import FW_Router from "./router";
import Table from "./templates/table";
import ModalWidget from "./templates/modal";
import Form from "./templates/form";
import AvailableData from "./templates/availableContractsList";
import Plain from "./templates/plain";
import InfoDataPanel from "./templates/infoPanel";
import Footer from "./templates/footer";
import Header from "./templates/header";
import CreditSubmit from "./templates/creditSubmitService";
import Custom from "./templates/custom";
import SubmitPaymentInfo from "./templates/submitPaymentInfo";
import Activate from "./templates/activate";
import ThankYou from "./templates/thank_you_page";
import Error from "./templates/errorPage";
import Hybrid from "./templates/hybrid";
import PaymentSuccess from "./templates/success";


const COSMOTETemplates = {
  index: Index,
  table: Table,
  form: Form,
  router: FW_Router,
  modal: ModalWidget,
  availableContractsData: AvailableData,
  plain: Plain,
  infoPanel: InfoDataPanel,
  footer: Footer,
  header: Header,
  creditSubmitService: CreditSubmit,
  custom: Custom,
  submitPaymentInfo: SubmitPaymentInfo,
  activatePage: Activate,
  thankYou: ThankYou,
  errorPage: Error,
  hybrid: Hybrid,
  payment: PaymentSuccess
};

export default COSMOTETemplates;
